import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { DesktopNavigatorTabFragment } from '../../../../generated/types';
import { tc } from '../../../../lib/trackingContext';
import { DesktopSiteNavPulldownV2 } from './DesktopSiteNavPulldownV2';

import './DesktopSiteNavTab.scss';

interface Props {
  tab: DesktopNavigatorTabFragment;
  className?: string;
  active: boolean;
}

export const DesktopSiteNavTab: React.FC<Props> = ({ tab, className, active }) => {
  const [isHovered, setHovered] = useState(false);

  const isTabEmpty = tab.units.length === 0;

  const handleMouseEnter = useCallback(() => {
    if (isTabEmpty) return;

    setHovered(true);
  }, [isTabEmpty]);

  const handleMouseLeave = useCallback(() => {
    if (isTabEmpty) return;

    setHovered(false);
  }, [isTabEmpty]);

  const handleTrackNavItemClicked = useCallback((url: string | null, text: string | null) => {
    tc.track('Navigation Item Clicked', {
      addToTrackingEvent: {
        url,
        text,
        label: text
      }
    });
  }, []);

  if (!tab.id || !tab.tabHeaderHref) return null;

  return (
    <div
      className={classNames('DesktopSiteNavTab', className)}
      data-label={tab.name?.toLowerCase()}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        className={classNames('DesktopSiteNavTab__link', {
          'DesktopSiteNavTab__link--bold': tab.style.isBold
        })}
        key={tab.id}
        to={tab.tabHeaderHref}
        style={{ color: tab.style.color ? tab.style.color : undefined }}
        onClick={() => handleTrackNavItemClicked(tab.tabHeaderHref, tab.name)}
      >
        {tab.name}
      </Link>

      <DesktopSiteNavPulldownV2 active={active} tab={tab} hovered={isHovered} />
    </div>
  );
};
